import { render } from "./designList.vue?vue&type=template&id=46c6b5d8&scoped=true&lang=html"
import script from "./designList.vue?vue&type=script&lang=js"
export * from "./designList.vue?vue&type=script&lang=js"

import "./designList.vue?vue&type=style&index=0&id=46c6b5d8&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c6b5d8"]])

export default __exports__